class VelouriaTabs extends HTMLElement {
  constructor() {
    super();
    this.triggers = Array.from(this.querySelectorAll('.velouria-product-tabs__trigger'));
    this.panels = Array.from(this.querySelectorAll('.velouria-product-tabs__panel'));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.select(trigger.dataset.tab));
    });
  }

  select(name) {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-selected', String(trigger.dataset.tab === name));
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== name;
    });
  }
}

customElements.define('velouria-tabs', VelouriaTabs);
